// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__KFqvw","choiceBoxes":"toolbarselects_choiceBoxes__2qvl2","simpleField":"toolbarselects_simpleField__3UMxj"};